<template>
  <div>
    <div class="scrollCardTermin-1 scrollContentLastDIV">
      <div class="container">
        <div class="scrollContentTitle">
          <h6 class="title title-up text-center navHeadline">Termin</h6>
          <h4 class="text-center title navHeadlineText">Wollen Sie einen Termin bei mir vor Ort haben?</h4>
        </div>

        <div class="row justify-content-md-center">
          <p class="text text-center col-lg-8">
            Dann werfen Sie einen Blick auf meinen <a v-scroll-to="'#kontaktanfahrt'" href>Kontakt</a> und sehen Sie, wie Sie mich finden und erreichen können.
            Ich nehme Ihre Anfrage gerne telefonisch an, sofern ich zum Zeitpunkt nicht reagiere, werde ich mich schnellstmöglich zurückmelden.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
    export default {
        name: "Termin"
    }
</script>

<style scoped>

</style>